/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsersDefaultBudgetDto } from '../../models/users-default-budget-dto';

export interface GetDefaultBudgetValues$Params {
}

export function getDefaultBudgetValues(http: HttpClient, rootUrl: string, params?: GetDefaultBudgetValues$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UsersDefaultBudgetDto>>> {
  const rb = new RequestBuilder(rootUrl, getDefaultBudgetValues.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UsersDefaultBudgetDto>>;
    })
  );
}

getDefaultBudgetValues.PATH = '/budget-management/default-budget-value';
